<div class="page-body">
  <div *ngIf="loading">
    <app-spinner></app-spinner>
  </div>

  <div *ngIf="!loading && backNavigationAllowed" class="banner">
    <button type="button" class="back-button" (click)="handleNavigateBack()">
      <app-zaver-icon [size]="14" name="chevronLeft"></app-zaver-icon>
    </button>
  </div>

  <div *ngIf="!loading" class="bank-selector-container">
    <header class="selector-header">
      <h1 class="heading">Välj din bank</h1>
      <p class="subheading">
        Koppla upp dig mot din bank och välja vilket konto du vill betala ifrån.
      </p>
    </header>

    <div class="search-wrapper">
      <app-zaver-icon class="search-icon" [size]="16" name="magnifyingGlass"></app-zaver-icon>
      <input id="bank-search" type="text" placeholder="Sök efter din bank..." (input)="onSearch($event)" class="search-input" />
    </div>

    <ul class="bank-list">
      <li *ngFor="let bank of displayedBanks" class="bank-item" (click)="selectBank(bank)">
        <div class="bank-info">
          <div class="bank-icon-wrapper">
            <img [src]="bank.logoUrl" [alt]="bank.name" class="bank-icon">
          </div>
          <span class="bank-name">{{ getBankDisplayName(bank.name) }}</span>
        </div>
        <span class="chevron-right">›</span>
      </li>
    </ul>

  </div>
</div>
